var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1WHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair1_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M571.5,152.9c1.7-30.1-8.9-59.9-27.9-83c-101.4-81.7-226.2-85.5-328-15.3c-74,51-132,146-97,195 c0.5,2.6,12.9,12.6,15.3,15.7c26.7,17.6,57.2-8.2,76-24.7c10.9-9.6,26.8-27.9,38.7-36c18.9-13,90.3-15.2,111-12.5l56,2 c0.9,0.7,57.6,2.7,58.5,3.5c20,18,28.5,55.7,29.4,70.6c6.1-16,18.8-29.1,34-39.4c12.6-13,22.2-28.8,27.9-45.8 C568.7,173.2,570.8,163,571.5,152.9z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M496.4,194l-0.8-17.3c-1.1-15.8-0.6-18.6-6.9-20.9c-1.2-0.4-2.4-0.8-3.6-1.3c-18-6.2-36.7-10.7-55.8-13.7 c-3.4-0.5-6.8-1-10.2-1.5c-27.9-4.8-56.6-7.1-85.5-6.1c-3.6,0.1-7.2,0.3-10.9,0.5c-31.6,2.2-62.8,7.7-91.5,19.2 c-1.3,0.5-2.7,1.1-4,1.6c-2.9,1.2-10.4-0.1-4.7,48.4l0.1,3.5c1.3,9.6,5.8,11.4,10.4,9.8c0.4-0.1,0.7-0.2,1.1-0.4 c1.9-0.7,3.9-1.3,5.8-1.9c14.2-4.2,28.7-7.4,43.4-9.7c7.4-1.2,14.8-2.1,22.3-2.8c35.1-3,70-3,104.4,0.6c6.9,0.7,13.7,1.5,20.5,2.6 c13.3,2.1,26.5,4.9,39.4,8.5C483.2,216.9,498.1,224.3,496.4,194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M333.6,133.3c29-1,57.6,1.3,85.5,6.1c3.4,0.5,6.8,0.9,10.2,1.5c19.1,3,37.8,7.5,55.8,13.7 c0.1-2.6,0.2-5.3,0.1-7.9c-0.1-3.4-0.3-6.7-0.7-10c-2.9-24.3-14.3-49.7-34.3-67.1c-2.9-2.5-5.9-4.8-9.1-6.9 c-17-11.8-37.6-16.5-58.8-17.7c-3.5-0.2-7.1-0.3-10.7-0.3c-37.7,0.4-79.3,4.4-107.5,28.9c-3,2.4-5.7,5-8.3,7.6 C237.1,100.8,230,127,231.2,153c28.7-11.4,59.9-17,91.5-19.2C326.3,133.6,330,133.4,333.6,133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M480.5,149.9c-2.5-1-4.9-2.1-7.5-3.1c-16.7-6.6-34-11.9-51.8-15.9c-3.6-0.8-7.1-1.6-10.7-2.3 c-39.5-7.9-80-8.9-119.9-4.3c-3.6,0.4-7.2,0.9-10.8,1.5c-7.1,1.2-14.1,2.7-20.9,4.7c3.4-31.6,22.2-61.5,51.2-79.5 c0.2-0.1,0.3-0.2,0.5-0.3C293.4,55,277.3,62,264.1,73.5c-3,2.4-5.7,5-8.3,7.6C237.1,100.8,230,127,231.2,153 c28.7-11.4,59.9-17,91.5-19.2c3.6-0.2,7.3-0.4,10.9-0.5c29-1,57.6,1.3,85.5,6.1c3.4,0.5,6.8,0.9,10.2,1.5 c19.1,3,37.8,7.5,55.8,13.7c0-0.8,0.1-1.7,0.1-2.5C483.6,151.3,482.1,150.6,480.5,149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M250.1,191.7c6.6-14.6,14.3-29.8,8-47.6c-9.1,2.5-18.1,5.4-26.8,8.9c-1.3,0.5-2.7,1.1-4,1.6 c-2.9,1.2-10.4-0.1-4.7,48.4l0.1,3.5c1.3,9.6,5.8,11.4,10.4,9.8c0.4-0.1,0.7-0.2,1.1-0.4c1.9-0.7,3.9-1.3,5.8-1.9 c4.8-1.4,9.6-2.7,14.5-3.9C251.6,204,247.9,197.3,250.1,191.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M362.1,34c-11.5-6.5-25,1.7-27.3,12.6c11.1-1.3,22.3-1.8,33.2-2C367.3,40.6,366.2,36.2,362.1,34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M322,137.1c3.6-0.2,7.3-0.4,10.9-0.5c29-1,57.6,1.3,85.5,6.1c3.4,0.5,6.8,0.9,10.2,1.5 c22.6,3.5,44.7,9.2,65.7,17.3c-0.8-3.2-2.2-4.5-5.5-5.7c-1.2-0.4-2.4-0.8-3.6-1.3c-6.6-2.3-13.3-4.3-20.1-6.2l-0.3-7.3 c-3.7-31.9-16.1-58.8-40.2-81.6c23.9,23.1,34.1,50.5,37.6,81.7l0.3,6.4c-10.8-2.8-21.7-5.1-32.8-6.8L429,134 c-4.2-30.4-14.3-55.5-30.9-81.3c16.3,26.1,24.2,51.6,28.2,81.6l0.6,6.1c-2.5-0.4-5.1-0.7-7.7-1.1c-9.7-1.7-19.5-3-29.3-4.1 l-0.3-6.3c-1.6-28-3.3-52.3-13.4-78.4c9.7,26.3,9.2,50.6,10.7,78.5l0.3,5.9c-10.1-1-20.4-1.6-30.6-1.9v-6 c-0.2-26.9-2.6-49.7-6.7-75.6c3.8,26,4,48.9,4.1,75.6v5.9c-6.7-0.1-13.5-0.1-20.2,0.2c-3.6,0.1-7.2,0.3-10.9,0.5 c-1.4,0.1-2.8,0.2-4.2,0.3l-0.4-5.4c-1.8-26.6-2.1-50.1,8.7-74.8c-11.1,24.5-13.2,48.1-11.4,75c0.1,1.9,0.3,3.7,0.4,5.5 c-11.1,1-22.2,2.4-33.2,4.3c-0.3-1.7-0.7-3.4-0.8-5.2c-2.6-24.8,0.7-46.9,11-69.9c-10.6,22.8-16.2,44.6-13.7,70.1 c0.2,1.8,0.5,3.6,0.9,5.4c-7.4,1.4-14.8,3-22,5c-0.2-1.5-0.5-3.1-0.6-4.6c-1.7-22.9,2.3-42.7,10.1-64.3 c-8.1,21.4-14.3,40.9-12.7,64.5c0.1,1.8,0.4,3.5,0.6,5.2c-8.2,2.3-16.3,5-24.2,8.1c-1.3,0.5-2.7,1.1-4,1.6 c-1.4,0.6-3.7,0.6-5.2,5.3c3.1-1.4,6.2-2.7,9.4-4C259.8,144.8,290.7,139.3,322,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M410.3,198.1c-34.4-3.6-69.3-3.6-104.4-0.6c-7.5,0.7-14.9,1.7-22.3,2.8c-14.7,2.3-29.2,5.5-43.4,9.7 c-2.3,0.7-4.6,1.4-6.9,2.2c-2.5,0.9-4.9,1.8-7.3,2.8c2,1.9,4.4,2.1,7,1.2c0.4-0.1,0.7-0.2,1.1-0.4c1.9-0.7,3.9-1.3,5.8-1.9 c14.2-4.2,28.7-7.4,43.4-9.7c7.4-1.2,14.8-2.1,22.3-2.8c35.1-3,70-3,104.4,0.6c6.9,0.7,13.7,1.5,20.5,2.6 c13.3,2.1,26.5,4.9,39.4,8.5c7.4,2.1,15.3,5.3,20.6,2.5c-19.1-6.9-39.2-11.8-59.6-15C424,199.6,417.2,198.8,410.3,198.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M249.5,204.7c-6.9-16.6-5.7-31.8-4.8-48.4c-0.4,16.7,1.7,31.5,8.4,47.1l1.9,4.1l-3.5,1.5L249.5,204.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M275,199.1c-5.6-17-6.6-32.2-4.3-49.1c-1.8,17,2.5,31.8,8,48c0.5,1.5,1.2,2.9,1.7,4.3l-3.6,1.3 C276.2,202.1,275.5,200.7,275,199.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M304.4,195.1c-4-17.3-5.5-32.4-4.8-49.6c-0.1,17.2,4.5,31.8,8.6,48.8l1.1,4.6l-3.8,0.8L304.4,195.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M336.5,192.9c-3.3-17.8-1.5-33.1,1.1-50.2c-2,17.2-0.6,32.4,2.8,49.5l1,4.6l-3.8,0.7L336.5,192.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M369.9,192.4c2.9-17.6,5.2-32.8,3.2-50.3c2.6,17.4,3.4,32.9,0.7,50.8l-0.8,4.8l-3.8-0.6L369.9,192.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M406.8,195.2c4.1-17.1,6-32.5,2.4-49.7c4.2,17,5.5,32.7,1.5,50.5l-1.3,4.7l-3.8-0.9L406.8,195.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M443,200.7c2.7-16.4,4-30.8,0.7-47.1c3.9,16,5.8,30.7,3.2,47.6l-0.8,4.5l-3.8-0.6L443,200.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M469.1,206c3.6-15.9,6.4-29.8,5-45.9c2,15.9,2.4,30.2-1.1,46.6l-1.1,4.3l-3.8-0.8L469.1,206z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M313.1,58.4c-0.4,1.6-1.4,2.8-2.3,2.7s-1.4-1.6-1-3.2c0.4-1.6,1.4-2.8,2.3-2.7S313.4,56.7,313.1,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M304,82.7c-0.3,1.3-1.1,2.3-1.9,2.2c-0.8-0.1-1.1-1.3-0.8-2.7c0.3-1.3,1.1-2.3,1.9-2.2 C303.9,80.2,304.2,81.4,304,82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M268.7,112.2c-0.3,1.3-1.1,2.3-1.9,2.2c-0.8-0.1-1.1-1.3-0.8-2.7c0.3-1.3,1.1-2.3,1.9-2.2 C268.6,109.6,269,110.8,268.7,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M263.3,190.5c0,1.4-0.5,2.5-1.3,2.5s-1.4-1.1-1.5-2.4c0-1.4,0.5-2.5,1.3-2.5 C262.6,188,263.2,189.1,263.3,190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M290.8,149.6c0.1,1.6-0.7,3-1.6,3s-1.7-1.3-1.8-2.9c0-1.6,0.7-3,1.6-3C290,146.7,290.8,148,290.8,149.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M288.3,188c0.4,1.6,0,3-0.9,3.2s-1.9-1-2.3-2.6s0-3,0.9-3.2S287.9,186.4,288.3,188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M318.4,169.6c0.3,1.6-0.2,3-1.2,3.1c-0.9,0.1-1.9-1.1-2.1-2.7c-0.3-1.6,0.2-3,1.2-3.1 C317.2,166.8,318.1,168,318.4,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M328.8,143.7c0,1.6-0.8,2.9-1.7,2.9c-0.9,0-1.6-1.3-1.6-3c0-1.6,0.8-2.9,1.7-2.9 C328.2,140.7,328.9,142.1,328.8,143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M355,147.2c0,1.6-0.8,2.9-1.7,2.9c-0.9,0-1.6-1.3-1.6-3c0-1.6,0.8-2.9,1.7-2.9 C354.3,144.2,355,145.6,355,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M350.8,184.6c0,1.6-0.8,2.9-1.7,2.9c-0.9,0-1.6-1.3-1.6-3c0-1.6,0.8-2.9,1.7-2.9S350.8,182.9,350.8,184.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M390.2,158.9c0,1.6-0.8,2.9-1.7,2.9c-0.9,0-1.6-1.3-1.6-3c0-1.6,0.8-2.9,1.7-2.9 C389.5,155.9,390.2,157.3,390.2,158.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M394.4,187.2c-0.3,1.6-1.2,2.8-2.1,2.7s-1.4-1.5-1.2-3.1c0.2-1.6,1.2-2.8,2.1-2.7 C394.1,184.2,394.6,185.6,394.4,187.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M432.4,181.2c-0.2,1.6-1.2,2.8-2.1,2.7s-1.4-1.5-1.2-3.1c0.2-1.6,1.2-2.8,2.1-2.7 C432.1,178.2,432.6,179.6,432.4,181.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -5.599824e-03 5.599824e-03 1 -0.9118 2.5612)",
    fill: "#FFFEFE",
    cx: 456.9,
    cy: 164.1,
    rx: 1.7,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M460.8,196.4c-0.1,1.6-1,2.9-1.9,2.8c-0.9-0.1-1.6-1.4-1.4-3c0.1-1.6,1-2.9,1.9-2.8 C460.3,193.4,461,194.7,460.8,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M485.5,167.4c0,2-1,3.7-2.1,3.6c-1.1,0-2.1-1.7-2-3.7c0-2,1-3.7,2.1-3.6 C484.6,163.7,485.5,165.3,485.5,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M296.5,111.6c-0.2,1.4-1.1,2.5-1.9,2.4s-1.3-1.3-1-2.7c0.2-1.4,1.1-2.5,1.9-2.4S296.8,110.2,296.5,111.6z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M278.1,74.3c-0.8,1.7-2.2,2.8-3.1,2.5c-1-0.3-1.1-2-0.4-3.7c0.8-1.7,2.2-2.8,3.1-2.5 C278.7,71,278.8,72.6,278.1,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M250.6,111.1c-0.5,1.8-1.7,3-2.7,2.8s-1.4-1.8-0.9-3.6c0.5-1.8,1.7-3,2.7-2.8 C250.6,107.8,251,109.4,250.6,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M243.1,133.9c-0.1,1.8-0.9,3.3-2,3.3c-1,0-1.8-1.5-1.8-3.3c0.1-1.8,0.9-3.3,2-3.3 C242.4,130.6,243.2,132.1,243.1,133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M233.7,182.3c-0.1,1.8-0.9,3.3-2,3.3c-1,0-1.8-1.5-1.8-3.3c0.1-1.8,0.9-3.3,2-3.3 C233,178.9,233.8,180.4,233.7,182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M257.4,165c-0.1,1.6-0.9,3-1.8,2.9c-0.9,0-1.6-1.4-1.6-3c0.1-1.6,0.8-3,1.8-2.9 C256.7,162,257.4,163.3,257.4,165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M234.4,205.8c0.3,1.4-0.1,2.7-0.8,2.8c-0.8,0.1-1.6-0.9-1.9-2.3c-0.3-1.4,0.1-2.7,0.8-2.8 S234.1,204.4,234.4,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M334.1,73.4c0,1.4-0.6,2.6-1.5,2.6c-0.8,0-1.5-1.1-1.5-2.6c0-1.4,0.6-2.6,1.5-2.6 C333.4,70.8,334.1,71.9,334.1,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M332.1,111.6c0,1.4-0.7,2.6-1.6,2.6c-0.8,0-1.5-1.2-1.4-2.6c0-1.4,0.7-2.6,1.6-2.6 C331.4,109,332.1,110.2,332.1,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M366.2,71.6c0,1.4-0.7,2.6-1.6,2.6c-0.8,0-1.5-1.2-1.4-2.6c0-1.4,0.7-2.6,1.6-2.6 C365.6,69,366.2,70.1,366.2,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M369.2,93.5c0,1.4-0.7,2.6-1.6,2.6c-0.8,0-1.5-1.2-1.5-2.6s0.7-2.6,1.6-2.6S369.2,92.1,369.2,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M395.1,69.4c0.2,1.4-0.3,2.6-1.1,2.7c-0.8,0.1-1.7-1-1.9-2.4c-0.2-1.4,0.3-2.6,1.1-2.7 C394,66.9,394.9,68,395.1,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M403.2,113.1c0.2,1.4-0.3,2.6-1.1,2.7c-0.8,0.1-1.7-1-1.9-2.4c-0.2-1.4,0.3-2.6,1.1-2.7 C402.1,110.6,403,111.7,403.2,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M429.6,87.1c0.4,1.4,0.1,2.7-0.7,2.9c-0.8,0.2-1.8-0.8-2.2-2.1c-0.4-1.4-0.1-2.7,0.7-2.9 C428.1,84.8,429.1,85.8,429.6,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M445.2,120.9c0.4,1.4,0.1,2.7-0.7,2.8c-0.8,0.2-1.8-0.8-2.2-2.2c-0.4-1.4-0.1-2.7,0.7-2.8 C443.8,118.5,444.8,119.5,445.2,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M465.2,99.5c0.4,1.4,0.1,2.7-0.7,2.8c-0.8,0.2-1.8-0.8-2.2-2.2c-0.4-1.4-0.1-2.7,0.7-2.8 C463.9,97.1,464.8,98.1,465.2,99.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1WHair1);
export default __webpack_public_path__ + "static/media/m-hat1_w-hair1.91d9f38e26f807190764d4be6bebe21d.svg";
export { ForwardRef as ReactComponent };